import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";
import TransactionSummarySkeleton from "./TransactionSummarySkeleton";
import {
  CELL_LABEL_HEIGHT,
  CELL_VALUE_HEIGHT,
  ITimelineSkeletonCell,
  TimelineSkeletonRow,
} from "./sharedSkeletonParts";

interface AuditDialogSkeletonProps {
  items?: number;
  showHeader?: boolean;
}

const CONTROL_HEIGHT = 34;
const FILTER_LABEL_HEIGHT = 20;
const FILTER_LABEL_WIDTH = 25;

const CELLS: ITimelineSkeletonCell[] = [
  { key: "audit-skeleton-cell-1", labelWidth: 80 },
  { key: "audit-skeleton-cell-2", labelWidth: 92 },
  { key: "audit-skeleton-cell-3", labelWidth: 88 },
  { key: "audit-skeleton-cell-4", labelWidth: 84 },
  { key: "audit-skeleton-cell-5", labelWidth: 90 },
];
const CELL_VALUE_WIDTHS = [88, 92, 84, 90, 86];

const FILTERS = [
  { key: "audit-skeleton-filter-1", widthClass: "width-250" },
  { key: "audit-skeleton-filter-2", widthClass: "width-200" },
  { key: "audit-skeleton-filter-3", widthClass: "width-200" },
  { key: "audit-skeleton-filter-4", widthClass: "width-150" },
  { key: "audit-skeleton-filter-5", widthClass: "width-150" },
];

interface AuditCellSkeletonProps {
  cell: ITimelineSkeletonCell;
  cellIndex: number;
  rows: number;
}

function AuditCellSkeleton({ cell, cellIndex, rows }: Readonly<AuditCellSkeletonProps>) {
  return (
    <>
      <div className="display-flex align-items-center gap-5 text-size-14">
        <ContentLoader className="display-block" height={CELL_LABEL_HEIGHT} width={cell.labelWidth} />
      </div>
      <div className="display-flex flex-column gap-10 margin-top-10">
        {Array.from({ length: rows }, (_unused, rowIndex) => (
          <ContentLoader
            key={rowIndex}
            className="display-block"
            height={CELL_VALUE_HEIGHT}
            width={CELL_VALUE_WIDTHS[(cellIndex + rowIndex) % CELL_VALUE_WIDTHS.length]}
          />
        ))}
      </div>
    </>
  );
}

export default function AuditDialogSkeleton({ items = 3, showHeader = true }: Readonly<AuditDialogSkeletonProps>) {
  return (
    <>
      {showHeader && (
        <>
          <TransactionSummarySkeleton />

          <div className="display-flex flex-wrap align-items-center gap-10 margin-top-15">
            {FILTERS.map((filter) => (
              <div key={filter.key} className={`${filter.widthClass} width-100pct-xs`}>
                <ContentLoader className="display-block" height={CONTROL_HEIGHT} width="100%" />
              </div>
            ))}

            <ContentLoader className="display-block" height={FILTER_LABEL_HEIGHT} width={FILTER_LABEL_WIDTH} />

            <div className="width-100pct-xs">
              <ContentLoader className="display-block" height={CONTROL_HEIGHT} width={110} />
            </div>
          </div>
        </>
      )}

      <div className="margin-top-15">
        {Array.from({ length: items }, (_, index) => {
          const rows = index === 0 ? 2 : 1;

          return (
            <TimelineSkeletonRow
              key={index}
              isLast={index === items - 1}
              cells={CELLS}
              renderCell={(cell, cellIndex) => <AuditCellSkeleton cell={cell} cellIndex={cellIndex} rows={rows} />}
            />
          );
        })}
      </div>
    </>
  );
}
